import { render } from "./DateTime.vue?vue&type=template&id=5e9aa817&lang=pug"
import script from "./DateTime.vue?vue&type=script&lang=ts"
export * from "./DateTime.vue?vue&type=script&lang=ts"
script.render = render

export default script